import {
  INSTRUCTOR_CREATE,
  UPDATE_ATTENDANCE,
  UPDATE_PAYMENT_RECEIPT_STATUS,
  UPDATE_GRADE,
  GET_COURSE_FULL_DETAILS,
  COURSE_FULL_DETAILS_UPDATED,
  START_COURSE,
  END_COURSE,
} from '../reducers'

import { getCourseFullDetails, courseFullDetailsUpdated } from '../reducers'

import { all, put, takeEvery } from 'redux-saga/effects'
import { push } from 'react-router-redux'

import * as firebase from 'firebase'
import * as moment from 'moment'

function* createProfile(action) {
  try {
    const userData = action.data
    const userCreationData = yield firebaseCreateProfile(userData)
    if (userCreationData) {
      yield put(push('/instructors'))
    }
  } catch (e) {
    //console.log('Error on createProfile ', e)
    // yield put({ type: FETCHING_DATA_FAILURE })
  }
}

const firebaseCreateProfile = data => {
  return firebase
    .auth()
    .createUserWithEmailAndPassword(data.email, data.password)
    .then(newUser => {
      const user = newUser.user
      const uid = user.uid
      const displayName = `${data.entitling} ${data.lastName} ${data.firstName}`
      // const phoneNumber = `${data.phoneNumber}`

      const p1 = user.updateProfile({
        displayName: displayName,
      })

      var updates = {
        [`instructors/${uid}`]: {
          displayName: displayName,
          phoneNumber: data.phoneNumber,
          firstName: data.firstName,
          lastName: data.lastName,
          entitling: data.entitling,
          email: data.email,
        },
        [`permissions/${uid}`]: {
          instructor: true,
        },
      }
      const p2 = firebase
        .database()
        .ref()
        .update(updates)

      const p3 = user.sendEmailVerification()

      return Promise.all([p1, p2, p3])
    })
}

function* updateAttendance(action) {
  try {
    //console.log('saga updateAttendance')
    const { courseId } = action.data
    yield firebaseUpdateAttendance(action.data)
    yield put(getCourseFullDetails(courseId))
  } catch (e) {
    //console.log('Error on updateAttendance', e)
  }
}

const firebaseUpdateAttendance = data => {
  const { courseId, studentId, day, hasAttended } = data
  const updates = {
    [`courses/${courseId}/attendance/${studentId}`]: hasAttended,
    [`students/${studentId}/courses/${courseId}/attendance`]: hasAttended,
  }

  return firebase
    .database()
    .ref()
    .update(updates)
}

function* updatePaymentReceiptStatus(action) {
  try {
    //console.log('saga updatePaymentReceiptStatus')
    const { courseId } = action.data
    yield firebaseUpdatePaymentReceiptStatus(action.data)
    yield put(getCourseFullDetails(courseId))
  } catch (e) {
    //console.log('Error on updatePaymentReceiptStatus', e)
  }
}

const firebaseUpdatePaymentReceiptStatus = data => {
  const { courseId, studentId, hasReceipt } = data
  const updates = {
    [`courses/${courseId}/payments/${studentId}/receipt`]: hasReceipt,
    [`students/${studentId}/payments/${courseId}/receipt`]: hasReceipt,
  }

  //console.log(updates)

  return firebase
    .database()
    .ref()
    .update(updates)
}

function* updateGrade(action) {
  try {
    //console.log('saga updateGrade')
    const { courseId } = action.data
    yield firebaseUpdateGrade(action.data)
    yield put(getCourseFullDetails(courseId))
  } catch (e) {
    //console.log('Error on updateGrade', e)
  }
}

const firebaseUpdateGrade = data => {
  const { courseId, studentId, grade } = data
  const updates = {
    [`courses/${courseId}/grades/${studentId}`]: grade,
    [`students/${studentId}/courses/${courseId}/grade`]: grade,
  }

  return firebase
    .database()
    .ref()
    .update(updates)
}

function* getCourseFullDetails$(action) {
  try {
    const courseDetails = yield firebaseGetCourseFullDetails(action.data)
    //console.log('saga course details', courseDetails)
    yield put(courseFullDetailsUpdated(courseDetails))
  } catch (e) {
    //console.log('Error on getCourseFullDetails', e)
  }
}

const firebaseGetCourseFullDetails = data => {
  const { courseId } = data

  return firebase
    .database()
    .ref(`courses/${courseId}`)
    .once('value')
    .then(response => {
      if (response.exists()) {
        const courseDetails = response.val()
        const studentIds = courseDetails.hasOwnProperty('students')
          ? Object.keys(courseDetails.students)
          : []

        return Promise.all(
          studentIds.map(id => {
            return firebase
              .database()
              .ref(`students/${id}`)
              .once('value')
          }),
        ).then(result => {
          const students = result.map(response => ({
            ...response.val(),
            id: response.key,
          }))

          return { courseId, course: courseDetails, students: students }
        })
      } else {
        //TODO throw error
      }
    })
}

function* startCourse$(action) {
  try {
    const { courseId } = action.data
    yield firsebaseStartCourse(action.data)
    //console.log('saga start course')
    yield put(push('/instructors-in-progress'))
  } catch (e) {
    //console.log('Error on startCourse', e)
  }
}

const firsebaseStartCourse = data => {
  const { courseId, course } = data

  const updates = {
    [`courseDetails/upcoming/${courseId}`]: null,
    [`courseDetails/in_progress/${courseId}`]: true,
    [`courses/${courseId}/status`]: 'in_progress',
  }

  Object.keys(course.students).filter(studentId => {
    updates[`students/${studentId}/courses/${courseId}/status`] = 'in_progress'
  })

  //console.log(updates)

  return firebase
    .database()
    .ref()
    .update(updates)
}

function* endCourse$(action) {
  try {
    const { courseId } = action.data
    yield firsebaseEndCourse(action.data)
    //console.log('saga end course')
    yield put(push('/instructors-completed'))
  } catch (e) {
    //console.log('Error on endCourse', e)
  }
}

const firsebaseEndCourse = data => {
  const { courseId, course } = data
  //console.log('course data', course)
  const currentYear = moment().year()

  // TODO - make additional checks
  let updates = {
    [`courseDetails/in_progress/${courseId}`]: null,
    [`courseDetails/completed/${courseId}`]: true,
    [`courses/${courseId}/status`]: 'completed',
  }

  Object.keys(course.students).map(studentId => {
    updates[`students/${studentId}/courses/${courseId}/status`] = 'completed'
    updates[`students/${studentId}/courses/${courseId}/year`] = currentYear

    // We need to check attendance for current student
    if (course.attendance.hasOwnProperty(studentId)) {
      updates[`students/${studentId}/courses/${courseId}/credits`] =
        course.credits
    } else {
      // The student was asbsent so he won't receive the credits
      updates[`students/${studentId}/courses/${courseId}/credits`] = 0
    }
  })

  //console.log('end course updates', updates)

  return firebase
    .database()
    .ref()
    .update(updates)
}

function* instructorsSaga() {
  try {
    yield all([
      takeEvery(INSTRUCTOR_CREATE, createProfile),
      takeEvery(UPDATE_ATTENDANCE, updateAttendance),
      takeEvery(UPDATE_PAYMENT_RECEIPT_STATUS, updatePaymentReceiptStatus),
      takeEvery(UPDATE_GRADE, updateGrade),
      takeEvery(GET_COURSE_FULL_DETAILS, getCourseFullDetails$),
      takeEvery(START_COURSE, startCourse$),
      takeEvery(END_COURSE, endCourse$),
    ])
  } catch (e) {
    //console.log('error in yield all', e)
  }
}

export default instructorsSaga



// WEBPACK FOOTER //
// ./src/sagas/instructorsSaga.js